module.exports = __webpack_public_path__ + "static/img/login-login-from-logo.29366276.png";